import { render, staticRenderFns } from "./SvgIconContainer.vue?vue&type=template&id=2852b2d8&"
import script from "./SvgIconContainer.vue?vue&type=script&lang=js&"
export * from "./SvgIconContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports